{
    "personalNumber": {
        "input": "ReceiverPersonalNumber",
        "attribute": "data-personalnumber",
        "reviewClass": ".review_receiver_personal_number",
        "payloadProp": "customerSsn"
    },
    "eMail": {
        "input": "ReceiverEmail",
        "attribute": "data-email",
        "reviewClass": ".review_receiver_email",
        "payloadProp": "customerEmail"
    },
    "name": {
        "input": "ReceiverName",
        "attribute": "data-name",
        "reviewClass": ".review_receiver_name",
        "payloadProp": "customerName"
    },
    "mobile": {
        "input": "ReceiverPhoneNumber",
        "attribute": "data-mobilephonenumber",
        "reviewClass": ".review_phone_number",
        "payloadProp": "customerPhoneNumber"
    }
}